import { applyAppTheme, initAppTheme, setAppTheme } from '@/utils/appTheme'
import { APPEARANCE_MODES, COLOR_THEMES, DEFAULT_THEME, readStoredTheme } from '@/config/appThemes'

const stored = typeof window !== 'undefined' ? readStoredTheme() : { ...DEFAULT_THEME }

const state = {
  colorId: stored.colorId,
  modeId: stored.modeId
}

const getters = {
  colorThemes: () => COLOR_THEMES,
  appearanceModes: () => APPEARANCE_MODES,
  currentColor: state => COLOR_THEMES.find(t => t.id === state.colorId) || COLOR_THEMES[2],
  currentMode: state => APPEARANCE_MODES.find(t => t.id === state.modeId) || APPEARANCE_MODES[0]
}

const mutations = {
  SET_THEME(state, payload) {
    if (payload.colorId) state.colorId = payload.colorId
    if (payload.modeId) state.modeId = payload.modeId
  }
}

const actions = {
  initTheme({ commit }) {
    const theme = initAppTheme()
    commit('SET_THEME', theme)
  },
  setColor({ commit }, colorId) {
    const theme = setAppTheme({ colorId })
    commit('SET_THEME', theme)
  },
  setMode({ commit }, modeId) {
    const theme = setAppTheme({ modeId })
    commit('SET_THEME', theme)
  },
  setTheme({ commit }, payload) {
    const theme = setAppTheme(payload)
    commit('SET_THEME', theme)
    return theme
  },
  reapply({ state }) {
    applyAppTheme({ colorId: state.colorId, modeId: state.modeId })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
